var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDashboardColor = function SvgDashboardColor(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2046 11.5543H12.7826C12.5964 11.5543 12.445 11.403 12.445 11.217V4.79533C12.445 4.30076 12.044 3.89978 11.5494 3.89978C9.12142 3.89978 6.79885 4.93767 5.17773 6.74757C3.55835 8.55595 2.78341 10.9879 3.05215 13.42C3.48617 17.3474 6.65192 20.5127 10.5795 20.9465C10.9017 20.9821 11.228 21.0002 11.5494 21.0002C11.5499 21.0002 11.5499 21.0002 11.5503 21.0002C13.834 21.0002 15.9812 20.1108 17.5958 18.4962C19.2107 16.8811 20.1003 14.734 20.1003 12.4499C20.1002 11.9553 19.6992 11.5543 19.2046 11.5543Z",
    fill: "#007AFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7043 3C14.205 3 13.8001 3.40486 13.8001 3.90422V9.29598C13.8001 9.79533 14.205 10.2002 14.7043 10.2002H20.0961C20.5954 10.2002 21.0003 9.79533 21.0003 9.29598C21.0003 5.82437 18.1759 3 14.7043 3Z",
    fill: "#00D7B2"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDashboardColor);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "dashboard-color.e09e8503d3590ab4de1136607ceaa4e5.svg";